import { useQuery, useMutation } from '@tanstack/react-query';
import { getLeaderboardPayoutsRest, retryFailedPayoutRest } from '@/services/leaderboards/leaderboards-service';
import { useState } from 'react';
import { showToast } from '@/common/showToast';

const useLeaderboard = () => {
  const [searchDate, setSearchDate] = useState<Date | null>(null);

  const { data: payouts, refetch: refetchPayouts } = useQuery({
    queryKey: ['leaderboard-payouts', searchDate],
    queryFn: () => (searchDate ? getLeaderboardPayoutsRest(searchDate) : []),
  });

  const { mutate: retryFailedPayout, isPending: isRetryFailedPayoutLoading } = useMutation({
    mutationFn: (payout: any) => retryFailedPayoutRest(payout),
    onSuccess: async () => {
      await refetchPayouts();
      showToast('Payout retried successfully', 'success');
    },
  });

  return {
    payouts,
    refetchPayouts,
    retryFailedPayout,
    isRetryFailedPayoutLoading,
    searchDate,
    setSearchDate,
  };
};

export default useLeaderboard;
